<template>
    <b-row>
        <b-col cols="12">
            <b-button
                class="m-3"
                :to="{
                    name: 'back.events.sesion.reservas',
                    params: { evento_id: evento.id, sesion_id: sesion.id }
                }"
            >
                Listado de reservas generadas
            </b-button>
        </b-col>
        <b-col cols="12" v-if="! zona_seleccionada">
            <b-tabs pills card align="center">
                <b-tab title="Svg" active>
                    <template v-if="evento.place_obj.tipo_svg === 1">
                        <CleSvgComponent
                            v-if="zonas.length > 0"
                            :zonas="zonas"
                            :place="evento.place_obj"
                            :sesion_id="sesion.id"
                            @clickZona="zonaSeleccionada" 
                        />
                    </template>
                    <SeccionesComponent
                        v-else
                        :event="evento"
                        :sesion_id="parseInt(sesion.id)"
                        @terminar="goTo(2, $event)"
                    />                    
                </b-tab>
                <b-tab title="Listado" v-if="evento.place_obj.tipo_svg === 1">
                    <TablaSectoresComponent
                        :zonas="zonas"
                        @goTo="zonaSeleccionada"
                    />
                </b-tab>
            </b-tabs>
        </b-col>
        <b-col cols="12" v-if="zona_seleccionada">
            <SelectAsientosBloqueadosComponent 
                :zona="zona_seleccionada" 
                :asientos="asientos_seleccionados"
                @addSeat="asientoSeleccionado"
                @deleteSeat="asientoQuitado"
            />
        </b-col>
        <template v-if="asientos_seleccionados.length > 0">
            <b-col cols="12">
                <h1>Asientos seleccionados:</h1>
                <ul>
                    <li v-for="(asiento, index) in asientos_seleccionados" :key="index">
                        Fila: {{ asiento.fila }} - Asiento: {{ asiento.asiento }}
                        <div class="form-group">
                            <label for="precio">Precio</label>
                            <ValidationProvider 
                                :name="'Precio entrada ' + index" 
                                rules=""
                                mode="passive" 
                                v-slot="{ errors }"
                            >
                                <multiselect
                                    v-if="asiento.precios"
                                    placeholder="Seleccione un precio"
                                    v-model="asiento.precioSelect"
                                    :show-labels="false"
                                    :options="asiento.precios"
                                    label="descripcion"
                                    :custom-label="customLabel"
                                    style="width: 97.3%"
                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                >
                                </multiselect>
                            </ValidationProvider>
                        </div>
                    </li>
                </ul>
            </b-col>
            <b-col cols="12">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                    <div class="form-group">
                        <label for="descuento">Descuento</label>
                        <select v-model="descuento" class="form-control" id="select-descuento">
                            <option value="0">Sin descuento</option>
                            <option v-for="(descuento, index) in configuracion.descuentos_disponibles" :key="index" :value="descuento">{{ descuento }}%</option>
                        </select>
                    </div>

                    <FormInput id="email" label="Email" name="Email" v-model="email" rules="required|email"/>

                    <b-button :disabled="loading" type="submit">Enviar</b-button>
                </ValidationObserver>                
            </b-col>
        </template>        
    </b-row>
</template>

<script>
import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';
import SelectAsientosBloqueadosComponent from '../../components/SelectAsientosBloqueadosComponent.vue';
import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent.vue';
import SeccionesComponent from '@/components/frontend/events/compra/components/secciones/SeccionesComponent';

export default {
    props: {
        evento: {
            type: Object,
            required: true
        },
        sesion: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            zonas: [],
            zona_seleccionada: null,
            filas: [],
            asientos_seleccionados: [],
            descuento: 0,
            email: '',
            loading: false
        }
    },
    created() {
        if(this.evento.place_obj.tipo_svg === 1) {
            this.getZonas();
        }        
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    methods: {
        getZonas() {
            const params = {
                filters: {
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                this.zonas = res.data;
            });
        },
        zonaSeleccionada(paso, zona) {
            this.zona_seleccionada = zona;
        },
        asientoSeleccionado(fila, asiento, status) {
            this.asientos_seleccionados.push({
                zona_id: this.zona_seleccionada.id,
                fila: fila,
                asiento: asiento,
                id: status.info.id,
                precios: this.zona_seleccionada.precios,
                precioSelect: asiento.precioSelect ? asiento.precioSelect : null
            });
        },
        asientoQuitado(fila, asiento) {
            this.asientos_seleccionados = this.asientos_seleccionados.filter(objeto => !(objeto.fila === fila && objeto.asiento === asiento));
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();

            if (isValid) {
                this.crearReserva();
            } else {
                this.$nextTick(function() {
                    this.$scrollTo('.is-invalid', 100)
                });
            }
        },
        crearReserva() {
            this.loading = true;

            const params = {
                filters: {},
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                asientos: this.asientos_seleccionados,
                descuento: this.descuento,
                email: this.email
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.reservas.create'), params).then(res => {
                this.$toast.success(res.data.message);
                this.reset();
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        reset() {
            this.zona_seleccionada = null;
            this.filas = [];
            this.asientos_seleccionados = [];
            this.descuento = 0;
            this.email = '';
        },
        customLabel({ descripcion, precio }) {
            return `${descripcion} – ${precio}€`
        }
    },
    components: {
        CleSvgComponent, SelectAsientosBloqueadosComponent, TablaSectoresComponent, SeccionesComponent
    }
}
</script>